import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable class-methods-use-this */
import { encode, decode } from 'base-64';
import { readBlob } from '../utils/tools';
var encodeb64 = typeof btoa !== 'undefined' ? btoa : encode;
var decodeb64 = typeof atob !== 'undefined' ? atob : decode;

var forgeBytes2Uint8Array = function forgeBytes2Uint8Array(data) {
  return Uint8Array.from(data, function (c) {
    return c.charCodeAt(0);
  });
}; // eslint-disable-next-line unused-imports/no-unused-vars-ts


var uint8Array2forgeBytes = function uint8Array2forgeBytes(arr) {
  return String.fromCharCode.apply(null, arr);
};

var base642Uint8Array = function base642Uint8Array(base64) {
  return Uint8Array.from(decodeb64(base64), function (c) {
    return c.charCodeAt(0);
  });
};

var uint8Array2base64 = function uint8Array2base64(arr) {
  return encodeb64(String.fromCharCode.apply(null, arr));
};

var hexString2Uint8Array = function hexString2Uint8Array(hexString) {
  return new Uint8Array(hexString.match(/.{1,2}/g).map(function (byte) {
    return parseInt(byte, 16);
  }));
};

var uint8Array2hexString = function uint8Array2hexString(arr) {
  return _toConsumableArray(arr).map(function (x) {
    return x.toString(16).padStart(2, '0');
  }).join('');
};

var importSecretKey = function importSecretKey(rawKey) {
  return window.crypto.subtle.importKey('raw', rawKey, 'AES-CBC', true, ['encrypt', 'decrypt']);
};

var hexKey2cyptokey = function hexKey2cyptokey(k) {
  return importSecretKey(hexString2Uint8Array(k));
};

var WebCryptoService = /*#__PURE__*/function () {
  function WebCryptoService() {
    _classCallCheck(this, WebCryptoService);
  }

  return _createClass(WebCryptoService, [{
    key: "encryptAESKeyWithRSA",
    value: function encryptAESKeyWithRSA(aesKey, pem) {
      // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-webcrypto-algorithms-00#section-5
      // RSAES-PKCS1-v1_5 has been known to be vulnerable to a chosen ciphertext attack (CCA) since 1998
      // eslint-disable-next-line
      return new NodeForgeService().encryptAESKeyWithRSA(aesKey, pem);
    }
  }, {
    key: "generateIV",
    value: function () {
      var _generateIV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", uint8Array2hexString(window.crypto.getRandomValues(new Uint8Array(16))));

            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));

      function generateIV() {
        return _generateIV.apply(this, arguments);
      }

      return generateIV;
    }()
  }, {
    key: "generateAESKey",
    value: function () {
      var _generateAESKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", uint8Array2hexString(window.crypto.getRandomValues(new Uint8Array(32))));

            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));

      function generateAESKey() {
        return _generateAESKey.apply(this, arguments);
      }

      return generateAESKey;
    }()
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, iv, message, isFile) {
        var k, dataToEncrypted;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return hexKey2cyptokey(key);

            case 2:
              k = _context3.sent;

              if (isFile) {
                dataToEncrypted = message;
              } else {
                dataToEncrypted = new TextEncoder().encode(message);
              }

              _context3.t0 = Uint8Array;
              _context3.next = 7;
              return window.crypto.subtle.encrypt({
                name: 'AES-CBC',
                iv: hexString2Uint8Array(iv)
              }, k, dataToEncrypted);

            case 7:
              _context3.t1 = _context3.sent;
              return _context3.abrupt("return", new _context3.t0(_context3.t1));

            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));

      function encrypt(_x, _x2, _x3, _x4) {
        return _encrypt.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key, iv, message, contentType) {
        var isFile, k, dataToDecypted, decrypted, fileDec;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              isFile = !contentType.includes('application/json');
              _context4.next = 3;
              return hexKey2cyptokey(key);

            case 3:
              k = _context4.sent;

              if (!(message instanceof Blob)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return readBlob(message);

            case 7:
              dataToDecypted = _context4.sent;
              _context4.next = 11;
              break;

            case 10:
              dataToDecypted = base642Uint8Array(message);

            case 11:
              _context4.next = 13;
              return window.crypto.subtle.decrypt({
                name: 'AES-CBC',
                iv: hexString2Uint8Array(iv)
              }, k, dataToDecypted);

            case 13:
              decrypted = _context4.sent;

              if (!isFile) {
                _context4.next = 17;
                break;
              }

              fileDec = new Blob([decrypted], {
                type: contentType
              });
              return _context4.abrupt("return", fileDec);

            case 17:
              return _context4.abrupt("return", new TextDecoder().decode(decrypted));

            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));

      function decrypt(_x5, _x6, _x7, _x8) {
        return _decrypt.apply(this, arguments);
      }

      return decrypt;
    }()
  }]);
}();

var NodeForgeService = /*#__PURE__*/function () {
  function NodeForgeService() {
    _classCallCheck(this, NodeForgeService);
  }

  return _createClass(NodeForgeService, [{
    key: "loadLib",
    value: function () {
      var _loadLib = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this._forge) {
                _context5.next = 4;
                break;
              }

              _context5.next = 3;
              return import('node-forge');

            case 3:
              this._forge = _context5.sent;

            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));

      function loadLib() {
        return _loadLib.apply(this, arguments);
      }

      return loadLib;
    }()
  }, {
    key: "encryptAESKeyWithRSA",
    value: function () {
      var _encryptAESKeyWithRSA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(aesKey, pem) {
        var forge, pki, publicKey, rsaEncryptedAesKey;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.loadLib();

            case 2:
              forge = this._forge;
              pki = this._forge.pki;
              publicKey = pki.publicKeyFromPem(forge.util.decode64(pem));
              rsaEncryptedAesKey = publicKey.encrypt(forge.util.createBuffer(aesKey, 'utf8').getBytes(), 'RSAES-PKCS1-V1_5');
              return _context6.abrupt("return", forge.util.encode64(rsaEncryptedAesKey));

            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));

      function encryptAESKeyWithRSA(_x9, _x10) {
        return _encryptAESKeyWithRSA.apply(this, arguments);
      }

      return encryptAESKeyWithRSA;
    }()
  }, {
    key: "generateIV",
    value: function () {
      var _generateIV2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var forge, iv;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.loadLib();

            case 2:
              forge = this._forge;
              iv = forge.util.bytesToHex(forge.random.getBytesSync(16));
              return _context7.abrupt("return", iv);

            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));

      function generateIV() {
        return _generateIV2.apply(this, arguments);
      }

      return generateIV;
    }()
  }, {
    key: "generateAESKey",
    value: function () {
      var _generateAESKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var forge, key;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.loadLib();

            case 2:
              forge = this._forge; // generate AES key

              key = forge.util.bytesToHex(forge.random.getBytesSync(32));
              return _context8.abrupt("return", key);

            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));

      function generateAESKey() {
        return _generateAESKey2.apply(this, arguments);
      }

      return generateAESKey;
    }()
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(key, iv, message) {
        var isFile,
            cipher,
            _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              isFile = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : false;
              _context9.next = 3;
              return this.loadLib();

            case 3:
              _context9.prev = 3;
              cipher = this._forge.cipher.createCipher('AES-CBC', this._forge.util.hexToBytes(key));
              cipher.start({
                iv: this._forge.util.hexToBytes(iv)
              });
              cipher.update(this._forge.util.createBuffer(message, isFile ? 'raw' : 'utf8'));
              cipher.finish();
              return _context9.abrupt("return", forgeBytes2Uint8Array(cipher.output.getBytes()));

            case 11:
              _context9.prev = 11;
              _context9.t0 = _context9["catch"](3);
              console.error(_context9.t0);

            case 14:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[3, 11]]);
      }));

      function encrypt(_x11, _x12, _x13) {
        return _encrypt2.apply(this, arguments);
      }

      return encrypt;
    }()
  }, {
    key: "decrypt",
    value: function () {
      var _decrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(key, iv, message, contentType) {
        var isFile, decipher, input, content, fileDec;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.loadLib();

            case 2:
              isFile = !contentType.includes('application/json');
              decipher = this._forge.cipher.createDecipher('AES-CBC', this._forge.util.hexToBytes(key));
              decipher.start({
                iv: this._forge.util.hexToBytes(iv)
              });

              if (!(message instanceof Blob)) {
                _context10.next = 12;
                break;
              }

              _context10.next = 8;
              return readBlob(message);

            case 8:
              content = _context10.sent;
              // Decrypt response from encrypted stream
              input = this._forge.util.createBuffer(content);
              _context10.next = 13;
              break;

            case 12:
              // Decrypt string such as jwt token
              input = this._forge.util.createBuffer(this._forge.util.decode64(message));

            case 13:
              decipher.update(input);
              decipher.finish();

              if (!isFile) {
                _context10.next = 18;
                break;
              }

              fileDec = new Blob([forgeBytes2Uint8Array(decipher.output.getBytes())], {
                type: contentType
              });
              return _context10.abrupt("return", fileDec);

            case 18:
              return _context10.abrupt("return", decipher.output.toString());

            case 19:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));

      function decrypt(_x14, _x15, _x16, _x17) {
        return _decrypt2.apply(this, arguments);
      }

      return decrypt;
    }()
  }]);
}();

var EncryptionService = /*#__PURE__*/function () {
  function EncryptionService(storage, encryptionModule) {
    _classCallCheck(this, EncryptionService);

    this._storage = storage;

    if (encryptionModule) {
      EncryptionService._service = encryptionModule;
    }
  }

  return _createClass(EncryptionService, [{
    key: "storage",
    get: function get() {
      return this._storage;
    }
  }, {
    key: "getAESKey",
    value: function getAESKey() {
      return this._storage.getItem('key');
    }
  }, {
    key: "generateAESKey",
    value: function () {
      var _generateAESKey3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var key;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return EncryptionService._service.generateAESKey();

            case 2:
              key = _context11.sent;
              this.storage.setItem('key', key);

            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));

      function generateAESKey() {
        return _generateAESKey3.apply(this, arguments);
      }

      return generateAESKey;
    }()
  }], [{
    key: "decodeCipher",
    value: function () {
      var _decodeCipher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(aesKey, iv, cipher, contentType) {
        var decryptedMessage;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return EncryptionService.decrypt(aesKey, iv, cipher, contentType);

            case 3:
              decryptedMessage = _context12.sent;

              if (!(decryptedMessage instanceof Blob)) {
                _context12.next = 6;
                break;
              }

              return _context12.abrupt("return", decryptedMessage);

            case 6:
              return _context12.abrupt("return", JSON.parse(decryptedMessage));

            case 9:
              _context12.prev = 9;
              _context12.t0 = _context12["catch"](0);
              return _context12.abrupt("return", decryptedMessage);

            case 12:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[0, 9]]);
      }));

      function decodeCipher(_x18, _x19, _x20, _x21) {
        return _decodeCipher.apply(this, arguments);
      }

      return decodeCipher;
    }()
  }, {
    key: "encryptAESKeyWithRSA",
    value: function encryptAESKeyWithRSA(aesKey, pem) {
      return this._service.encryptAESKeyWithRSA(aesKey, pem);
    }
  }, {
    key: "generateIV",
    value: function generateIV() {
      return this._service.generateIV();
    }
  }, {
    key: "encrypt64",
    value: function () {
      var _encrypt3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(key, iv, message) {
        var encrypted;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return EncryptionService.encrypt(key, iv, message);

            case 2:
              encrypted = _context13.sent;
              return _context13.abrupt("return", uint8Array2base64(encrypted));

            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));

      function encrypt64(_x22, _x23, _x24) {
        return _encrypt3.apply(this, arguments);
      }

      return encrypt64;
    }()
  }, {
    key: "encrypt",
    value: function encrypt(key, iv, message) {
      var isFile = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return this._service.encrypt(key, iv, message, isFile);
    }
  }, {
    key: "encryptFile",
    value: function () {
      var _encryptFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(key, iv, value) {
        var fileContent, encryptedContent, encryptedFile;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return readBlob(value);

            case 2:
              fileContent = _context14.sent;
              _context14.prev = 3;
              _context14.next = 6;
              return EncryptionService.encrypt(key, iv, fileContent, true);

            case 6:
              encryptedContent = _context14.sent;
              encryptedFile = new File([encryptedContent], "".concat(value.name), {
                type: value.type,
                lastModified: value.lastModified
              });
              return _context14.abrupt("return", encryptedFile);

            case 11:
              _context14.prev = 11;
              _context14.t0 = _context14["catch"](3);
              console.error(_context14.t0);

            case 14:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[3, 11]]);
      }));

      function encryptFile(_x25, _x26, _x27) {
        return _encryptFile.apply(this, arguments);
      }

      return encryptFile;
    }()
  }, {
    key: "decrypt",
    value: function decrypt(key, iv, message, contentType) {
      return this._service.decrypt(key, iv, message, contentType);
    }
  }]);
}();

_defineProperty(EncryptionService, "_service", typeof window !== 'undefined' && typeof window.crypto !== 'undefined' && typeof window.crypto.subtle !== 'undefined' ? new WebCryptoService() : new NodeForgeService());

export default EncryptionService;
//# sourceMappingURL=encryption.js.map